import * as ListingBffRepository from './listingBffRepository';
import searchResultTranslator from './searchResultTranslator';

export default (searchConditionQuery, featureFlags) => (
  ListingBffRepository.searchListings(searchConditionQuery, featureFlags)
    .then(data => searchResultTranslator(data))
    .catch(e => Promise.reject(new Error(`An error occurred during the request to the server: ${e}`)))
);
